import axios from 'axios'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

const PatientAdd = () => {
    const [name, setName] = useState('')
    const [age, setAge] = useState('')
    const [phone, setPhone] = useState('')
    const [previousVisited, setPreviousVisited] = useState(false)
    const [givenMedicine, setGivenMedicine] = useState('')
    const [visitedPurpose, setVisitedPurpose] = useState('')
    const navigate = useNavigate()
    const handleSubmit = async (e) => {
         e.preventDefault();
        const patientData = { name, age, phone, previous_visited: previousVisited, given_medicine: givenMedicine, visited_purpose: visitedPurpose };
        console.log('patientData: ', patientData)
        try {
            axios.post(`${process.env.REACT_APP_BASE_URL}/patients`, patientData)
            navigate('/')
        } catch (error) {
            console.log('Error: ', error)
        }
    }
  return (
    <div>
        <h1>PatientAdd</h1>
        <div>
        <form onSubmit={handleSubmit} style={{display: 'flex', flexDirection: 'column', gap: '10px', width: '450px', padding: '20px'}}>
            <input type='text' value={name} onChange={(e) => setName(e.target.value)} placeholder='Enter Name'  />
            <input type='number' value={age} onChange={(e) => setAge(e.target.value)} placeholder='Enter Age'  />
            <input type='number' value={phone} onChange={(e) => setPhone(e.target.value)} placeholder='Enter Phone'  />
            <input type='text' value={previousVisited} onChange={(e) => setPreviousVisited(e.target.value)} placeholder='Enter Previous Visit'  />
            <input type='text' value={givenMedicine} onChange={(e) => setGivenMedicine(e.target.value)} placeholder='Enter Given Medicine'  />
            <input type='text' value={visitedPurpose} onChange={(e) => setVisitedPurpose(e.target.value)} placeholder='Enter Visited Purpose'  />
            <button>Submit</button>
        </form>
        </div>
    </div>
  )
}

export default PatientAdd

/* 
name
age
given_medicine
phone
previous_visited
visited_purpose
*/